type Features = {
  opportunity: boolean
  meetingMinuteEmailComposer: boolean
  meetingInternalNote: boolean
  showLeadActivityId: boolean
}

export const activeFeature: Features = {
  opportunity: true,
  meetingMinuteEmailComposer: true,
  meetingInternalNote: true,
  showLeadActivityId: true,
}

export default activeFeature
